// @ts-check

import { useTemplateDataGridContext } from '~/components/Forms/TemplateDataGrid/TemplateDataGrid.context';
import GridExportButton from '~/components/Shared/DataGrid/GridExportButton';

const EXPORTED_ROW_COUNT = 150;

export default function TemplateDataGridExportButton() {
    const { gridRef, setRowCount } = useTemplateDataGridContext();

    return (
        <GridExportButton
            gridRef={gridRef}
            setRowCount={setRowCount}
            exportRowCount={EXPORTED_ROW_COUNT}
            fileName="ZERO Templates Export"
        />
    );
} 